import React from "react";
import { url } from "lib/format";
import LuvitComponent from "LuvitComponent";
import { IconButton } from "lib/components/Button";

let timer = null;

export default class SearchBar extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "Menu");
    this.search = this.search.bind(this);
    this.empty = this.empty.bind(this);
    this.dontEmpty = this.dontEmpty.bind(this);
    this.focusOnSearch = this.focusOnSearch.bind(this);
  }

  componentWillMount() {
    this.setState({});
  }

  onKeyDown(index, event) {
    if (event.keyCode == 13 && index === 1000) event.preventDefault();
  }

  search() {
    let val = this.refs.inputSearch.value.toLowerCase();

    let courses = null;
    let menuItems = null;

    if (val) {
      let searchMap = this.state.searchMap;
      if (!searchMap) {
        searchMap = Object.keys(this.props.menu).map((a) => {
          let b = this.props.menu[a];
          let parent =
            b.parentId &&
            this.props.menu[b.parentId] &&
            this.l(this.props.menu[b.parentId].name);

          return {
            name: this.l(b.name).toLowerCase(),
            val: b,
            parent,
            sParent: (parent || "").toLowerCase(),
          };
        });
        this.setState({ searchMap });
      }

      courses = this.props.courses.filter(
        (a) => a.title.toLowerCase().indexOf(val) >= 0,
      );

      menuItems = searchMap.filter(
        (a) =>
          a.val.url &&
          (a.name.indexOf(val) >= 0 || a.sParent.indexOf(val) >= 0),
      );
    }

    this.setState({ courses, menuItems });
  }

  focusOnSearch() {
    this.refs.inputSearch.focus();
  }

  empty() {
    timer = setTimeout(
      (() => {
        this.refs.inputSearch.value = "";
        this.setState({ courses: null, menuItems: null, hasFocus: false });
      }).bind(this),
      500,
    );
  }

  dontEmpty() {
    clearTimeout(timer);
    this.setState({ hasFocus: true });
  }

  renderSearchList(index = 0) {
    let state = this.state || {};
    let urlPrefix = url("/education/entercourse.aspx?courseid=");

    return (
      <ul
        className="list flex flex-space-b column"
        id="searchbar-list"
        role="listbox"
      >
        {state.menuItems &&
          state.menuItems.map((a, i) => (
            <li className="list-item flex" key={i}>
              <a
                title={this.l(a.val.name)}
                href={url(a.val.url)}
                className="menu-expandlist-title"
              >
                <p>{this.l(a.val.name)}</p>
                {a.parent && <span> {a.parent} </span>}
              </a>{" "}
            </li>
          ))}

        {state.courses &&
          state.courses.map((a) => (
            <li className="list-item flex" key={a.id}>
              <a
                title={a.title}
                href={urlPrefix + a.id}
                className="menu-expandlist-title"
              >
                <p>{a.title}</p>
                <span>{this.l("course")}</span>
              </a>
            </li>
          ))}
      </ul>
    );
  }

  doRender() {
    let state = this.state || {};
    let index = 0;

    return (
      <div
        className={"searchbar " + (state.hasFocus ? "focused" : "")}
        onBlur={this.empty}
        onFocus={this.dontEmpty}
        role="menuitem"
      >
        <span>
          <input
            type="text"
            ref="inputSearch"
            role="combobox"
            aria-controls="searchbar-list"
            aria-autocomplete="list"
            aria-expanded={
              state.menuItems && state.menuItems.length > 0 ? true : false
            }
            onKeyUp={this.search}
            tabIndex={index}
            placeholder={this.l("searchinmenu")}
            name={this.l("search")}
            aria-label={this.l("searchinmenu")}
          />
          <IconButton
            icon="icon-search"
            label={this.l("search")}
            onClick={this.focusOnSearch}
            overridefocus="--colorLeftMenuFocus"
          />
        </span>

        {((state.menuItems && state.menuItems.length > 0) ||
          (state.courses && state.courses.length > 0)) &&
          this.renderSearchList(index)}
      </div>
    );
  }
}
